/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
// Dependencies
import React, {useState, useEffect} from 'react'
import {connect} from 'react-redux'

// Actions
import {storePayload} from '../actions/storePayload'
import {breakCode} from '../actions/breakCode'

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import stylesOutputWrapper from '../styles/OutputWrapper.module.css'

// Images
// import OutputBackground from '../images/SystemBackground.svg'
import ATLSLogo from '../images/ATLS.svg'

// Components
import TopRow from './TopRow'
import StepFeed from './StepFeed'
import ModuleLogList from './ModuleLogList'
import CoreModule from './CoreModule'
import ProcessOutput from './ProcessOutput'
import LogTable from './LogTable'
import CodeCompare from './CodeCompare'
import UserFeedback from './UserFeedback'
import CodeBreakButton from './CodeBreakButton'
import PromptModal from './PromptModal'

function OutputWrapper(props) {
  const [activeModules, setActiveModules] = useState([])
  const [thinkingModules, setThinkingModules] = useState([])

  function onClickStep(stepIndex) {
    console.log(stepIndex)
  }

  useEffect(() => {
    if (props.modules) {
      setActiveModules(['claims', 'm&a', 'underwriting', 'code', 'loans']
          .filter((key) => {
            return isModuleRunning(key)
          }))
      setThinkingModules(['claims', 'm&a', 'underwriting', 'code', 'loans']
          .filter((key) => {
            return isModuleThinking(key)
          }))
    }
  }, [props.modules])

  function isModuleRunning(moduleKey) {
    const status = props.modules?.[moduleKey]?.status?.toLowerCase()
    if (status && (status === 'running' || status.includes('code'))) {
      return true
    } else {
      return false
    }
  }

  function isModuleThinking(moduleKey) {
    const status = props.modules?.[moduleKey]?.status?.toLowerCase()
    if (status === 'thinking') {
      return true
    } else {
      return false
    }
  }

  return (
    <div className={stylesOutputWrapper['outputs-page']}>
      <TopRow />
      <div className={stylesOutputWrapper['outputs-wrapper']}>
        <div className={stylesOutputWrapper['outputs']}>
          {/* this random div is placeholder just to render this */}
          {/* Routes */}
          <ModuleLogList
            moduleKey={'claims'}
          />
          <ModuleLogList
            moduleKey={'m&a'}
          />
          <ModuleLogList
            moduleKey={'loans'}
          />
          <ModuleLogList
            moduleKey={'underwriting'}
          />
          <CoreModule
            title={'ATLS Agentic Core'}
            logs={[]}
            type={'core'}
          />
          <ModuleLogList
            moduleKey={'code'}
            isCodeModule={true}
          />
          <div
            className={
              `${stylesOutputWrapper['connecting-line']} ${stylesOutputWrapper['ne']} ${activeModules.includes('m&a') ? stylesOutputWrapper['active-connecting-line'] : thinkingModules.includes('m&a') ? stylesOutputWrapper['thinking-connecting-line'] : ''}`
            }
          />
          <div
            className={
              `${stylesOutputWrapper['connecting-line']} ${stylesOutputWrapper['nw']} ${activeModules.includes('claims') ? stylesOutputWrapper['active-connecting-line'] : thinkingModules.includes('claims') ? stylesOutputWrapper['thinking-connecting-line'] : ''}`
            }
          />
          <div
            className={
              `${stylesOutputWrapper['connecting-line']} ${stylesOutputWrapper['se']} ${activeModules.includes('underwriting') ? stylesOutputWrapper['active-connecting-line'] : thinkingModules.includes('underwriting') ? stylesOutputWrapper['thinking-connecting-line'] : ''}`
            }
          />
          <div
            className={
              `${stylesOutputWrapper['connecting-line']} ${stylesOutputWrapper['sw']} ${activeModules.includes('loans') ? stylesOutputWrapper['active-connecting-line'] : thinkingModules.includes('loans') ? stylesOutputWrapper['thinking-connecting-line'] : ''}`
            }
          />
          <div
            className={
              `${stylesOutputWrapper['connecting-line']} ${stylesOutputWrapper['s']} ${activeModules.includes('code') ? stylesOutputWrapper['active-connecting-line'] : thinkingModules.includes('code') ? stylesOutputWrapper['thinking-connecting-line'] : ''}`
            }
          />
          <PromptModal />
          {/* <>
            <div
              style={{
                width: '40%',
                height: '100%',
                backgroundColor: '#000',
              }}
            >
              <StepFeed
                topText={'Today you will be given a claims package. Your job is to identify whether or not this specific claim is legitimate. You have a toolkit available to you to examine and interrogate this claim. You can run all the pdfs at once. Please run through each set of files and identify whether or not this claim should be paid or if it is fraudulent. Common things to look for are different claimants, different makes, models, or years of the vehicle(s), different policy numbers, inconsistent reporting of damage, excessively high repairs, etc. You can start by invoking the view_package function. If there\'s a video, view that first. \nWhen you\'re ready, give your final answer in the form of an analyst brief. Whatever your decision, give me your full reasoning including specifics.'}
                steps={[
                  {
                    title: 'View Package',
                    sources: ['a.png', 'b.txt', 'b.txt', 'b.txt', 'c.mov', 'c.mov', 'c.mov', 'c.mov'],
                    description: 'This package contains a folder of vehicle images, two PDF documents, an audio file, and a video file.',
                  },
                  {
                    title: 'Analyze Video',
                    sources: ['c.mov'],
                    description: 'The video shows a 2002 Toyota Avalon crashing and an individual fleeing the scene. A policy officer arrives shortly after. The car is extensively damaged, especially on the front and front left side. The car is grey. This information could be relevant to the claim.',
                  },
                  {
                    title: 'Summarize Audio',
                    sources: ['c.mp3'],
                    description: 'The audio file is a call between John and State Farm, reporting a car accident involving his stolen Toyota Avalon. The car was stolen outside his auto body shop and later crashed, with the incident being captured on a home surveillance camera. The car has been recovered, but it’s too damaged for repairs. John also mentioned the potential loss of some tools from the car. The claim number is CLM 7890123. This information aligns with the video. ',
                  },
                  {
                    title: 'Analyze Documents',
                    sources: ['a.pdf', 'b.txt'],
                    description: 'Next, I should examine the PDF documents.',
                  },
                ]}
                onClickStep={onClickStep}
              />
            </div>
            <div
              style={{
                width: '100%',
                height: '100%',
                backgroundColor: '#1a1a1a',
              }}
            >
              <ProcessOutput
                stepBackgroundColor={'#1a1a1a'}
              />
            </div>
            <div
              style={{
                width: '40%',
                height: '100%',
              }}
            >
              <LogTable
                logs={[
                  {action: 'action1 action1 action1 action1 action1 action1 action1 action1', timestamp: 1234567800000},
                  {action: 'action2', timestamp: 1776678000000},
                ]}
              />
            </div>
            <div
              style={{
                width: '100%',
                height: '100%',
              }}
            >
              <CodeCompare
                leftSide={{
                  title: 'Error Code',
                  description: 'First error message goes here. First error message goes here.First error message goes here. First error message goes here.First error message goes here. First error message goes here.First error message goes here. First error message goes here.First error message goes here. First error message goes here.',
                  infoIcon: 'alert-triangle',
                  code: `from PIL import Image\n\n# Open the image\nimg = Image.open('image.jpg')\n# Get the width and height of the image\nwidth, height = img.size\n# Create a new image with every other pixel removed\nnew_img = Image.new('RGB', (width, height))\nfor x in range(0, width, 2):\n    for y in range(0, height, 2):\n        # Get the pixel values at the current position\n        r, g, b = img.getpixel((x, y))\n        # Set the pixel values at the corresponding position in the new image\n        new_img.putpixel((x, y), (r, g, b))\n\n# Save the new image\nnew_img.save('new_image.jpg')\n\nfrom PIL import Image\n\n# Open the image\nimg = Image.open('image.jpg')\n# Get the width and height of the image\nwidth, height = img.size\n# Create a new image with every other pixel removed\nnew_img = Image.new('RGB', (width, height))\nfor x in range(0, width, 2):\n    for y in range(0, height, 2):\n        # Get the pixel values at the current position\n        r, g, b = img.getpixel((x, y))\n        # Set the pixel values at the corresponding position in the new image\n        new_img.putpixel((x, y), (r, g, b))\n\n# Save the new image\nnew_img.save('new_image.jpg')`,
                  codeLanguage: 'python',
                }}
                rightSide={{
                  title: 'Fixed Code',
                  description: 'First error message goes here. First error message goes here.First error message goes here. First error message goes here.First error message goes here. First error message goes here.First error message goes here. First error message goes here.First error message goes here. First error message goes here.',
                  infoIcon: 'checkmark-circle-2',
                  code: `from PIL import Image\n\n# Open the image\nimg = Image.open('image.jpg')\n# Get the width and height of the image\nwidth, height = img.size\n# Create a new image with every other pixel removed\nnew_img = Image.new('RGB', (width, height))\nfor x in range(0, width, 2):\n    for y in range(0, height, 2):\n        # Get the pixel values at the current position\n        r, g, b = img.getpixel((x, y))\n        # Set the pixel values at the corresponding position in the new image\n        new_img.putpixel((x, y), (r, g, b))\n\n# Save the new image\nnew_img.save('new_image.jpg')`,
                  codeLanguage: 'python',
                }}
              />
            </div>
          </> */}
          {props.isCodeBreakUser && <CodeBreakButton
            onClick={() => {
              props.storePayload({
                isExpectingCodeBreak: true,
              })
              props.breakCode()
            }}
          />}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  user: state.userReducer.user,
  isCodeBreakUser: state.userReducer.isCodeBreakUser,
  modules: state.userReducer.modules,
})

export default connect(
    mapStateToProps,
    {storePayload, breakCode},
)(OutputWrapper)
